import React from 'react'
import Skeleton from 'react-loading-skeleton'

const UsersHighlightsTopSkeleton = () => {
    return (
        <>
        <div className="col-12">
                      <Skeleton height='2em' width='30%' />
                    </div>
            <div className="col-sm-4 mb-2 align-items-center">
                <Skeleton />
                <div>
                    <div className="center">
                        <Skeleton height='2.6em' />
                    </div>
                </div>
            </div>
            <div className="col-sm-4 mb-2 right-dropdown-container align-items-center">
                <Skeleton />
                <div>
                    <div className="center">
                        <Skeleton height='2.6em' />
                    </div>
                </div>
            </div>
            <div className="col-sm-4 mb-2 align-items-center">
                <Skeleton />
                <div className="toggle-button right-toggle-container">
                    <div className="center">
                        <Skeleton height='2.6em' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default UsersHighlightsTopSkeleton